export default {
  state: {
    packages: {
      isLoading: false,
      items: [],
      checked: [],
      checkedForDispatch: [],
      paging: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      },
      sort: {
        order: 'p.pickupTime',
        asc: true
      },
      pickupTimeModal: {
        show: false,
        loading: false,
        success: false,
        message: '',
        id: 0,
        value: ''
      }
    },
    totalItem: {
      pkg: 0,
      rsvp: 0
    }
  },
  mutations: {
    // Packages
    setIsPackagesLoading (state, value) { state.packages.isLoading = value },
    setPackageItems (state, value) {
      state.packages.items = value
      state.packages.checked = []
      state.packages.checkedForDispatch = []
    },
    addPackage (state, value) {
      state.packages.items.push(value)
    },
    updatePackagePoolStatus (state, value) {
      let index = state.packages.items.findIndex(opPackage => opPackage.id === value.id)
      state.packages.items[index].inPool = value.inPool
    },
    removePackageItem (state, id) {
      let index = state.packages.items.findIndex(opPackage => opPackage.id === id)
      state.packages.items.splice(index, 1)
    },
    updatePackage (state, value) {
      let items = state.packages.items
      let index = items.findIndex(item => item.id === value.id)
      if (index < 0) {
        return
      }
      items[index] = value
      state.package.items = items
    },

    // Checked packages
    updateCheckedPackages (state, value) { state.packages.checked = value },
    clearCheckedPackages (state) { state.packages.checked = [] },

    // Checked packages for dispatch
    updateCheckedPackagesForDispatch (state, value) { state.packages.checkedForDispatch = value },
    clearCheckedPackagesForDispatch (state) { state.packages.checkedForDispatch = [] },

    // Paging mutations
    setPackageCurrentPage (state, value) { state.packages.paging.currentPage = value },
    setPackageTotalPages (state, totalItems) {
      state.packages.paging.totalPages = Math.ceil(totalItems / state.packages.paging.pageSize)
    },
    resetPackagePaging (state) {
      state.packages.paging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      }
    },

    // Sorting mutations
    setPackagesSort (state, value) { state.packages.sort = value },

    setPickupTimeModal (state, data) {
      for (let field in data) {
        state.packages.pickupTimeModal[field] = data[field]
      }
    },
    updatePickupDate (state, data) {
      let index = state.packages.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.packages.items[index].pickupTime = data.value
      }
    },
    setRoutingPkgTotal (state, value) { state.totalItem.pkg = value },
    setRoutingRsvpTotal (state, value) { state.totalItem.rsvp = value },

    setPendingOffer (state, data) {
      let i = state.packages.items.findIndex(x => x.id === data.id)
      if (i > -1) {
        state.packages.items[i].pendingOffer = {
          show: data.show,
          timer: data.timer
        }
      }
    },
    updateRsvpStatus (state, data) {
      let i = state.packages.items.findIndex(x => x.id === data.id)
      if (i > -1) {
        state.packages.items[i].status = data.status
        state.packages.items[i].statusClass = data.statusClass
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/routing/routing-packages.js